import { IMPRESSUM, LEGAL_VERSION, OPERATOR, PRIVACY, TERMS, type ContractText, type LegalSection } from '@fsv/data';

function Section({ section }: { section: LegalSection }) {
  return (
    <section className="legal__section" aria-labelledby={`legal-${section.id}`}>
      <h2 id={`legal-${section.id}`}>{section.title}</h2>
      {section.paragraphs?.map((p) => (
        <p key={p.slice(0, 32)}>{p}</p>
      ))}
      {section.items && (
        <dl className="legal__items">
          {section.items.map((item) => (
            <div key={item.term}>
              <dt>{item.term}</dt>
              <dd>{item.text}</dd>
            </div>
          ))}
        </dl>
      )}
      {section.list && (
        <ul>
          {section.list.map((li) => (
            <li key={li.slice(0, 32)}>{li}</li>
          ))}
        </ul>
      )}
    </section>
  );
}

/** The platform operator's privacy statement (texts.ts). */
export function PrivacyStatement() {
  return (
    <div className="legal">
      <h1>{PRIVACY.title}</h1>
      <p className="legal__date">Stand: {LEGAL_VERSION}</p>
      <p className="legal__lede">{PRIVACY.intro}</p>
      {PRIVACY.sections.map((s) => (
        <Section key={s.id} section={s} />
      ))}
    </div>
  );
}

/** The operator's terms of use for members (texts.ts; no acceptance step, the club informs its members). */
export function TermsOfUse() {
  return (
    <div className="legal">
      <h1>{TERMS.title}</h1>
      <p className="legal__date">Stand: {TERMS.version}</p>
      <p className="legal__lede">{TERMS.intro}</p>
      {TERMS.sections.map((s) => (
        <Section key={s.id} section={s} />
      ))}
    </div>
  );
}

/** A contract text of the club (AGB, AVV — @fsv/core legal.ts), e.g. in the sign-up form's sheet. */
export function ContractTextView({ text, headingLevel = 1 }: { text: ContractText; headingLevel?: 1 | 2 }) {
  const H = headingLevel === 1 ? 'h1' : 'h2';
  return (
    <div className="legal">
      <H>{text.title}</H>
      <p className="legal__date">Fassung vom {text.version}</p>
      <p className="legal__lede">{text.intro}</p>
      {text.sections.map((s) => (
        <Section key={s.id} section={s} />
      ))}
    </div>
  );
}

/** The operator's Impressum, verbatim (see texts.ts header). */
export function Impressum() {
  return (
    <div className="legal">
      <h1>{IMPRESSUM.title}</h1>
      <p>{IMPRESSUM.basis}</p>
      <address className="legal__address">
        {OPERATOR.name}
        <br />
        {OPERATOR.street}
        <br />
        {OPERATOR.city}
        <br />
        {OPERATOR.country}
      </address>
      <dl className="legal__items">
        {IMPRESSUM.rows.map((r) => (
          <div key={r.term}>
            <dt>{r.term}</dt>
            <dd>{r.term === 'E-Mail' ? <a href={`mailto:${r.text}`}>{r.text}</a> : r.text}</dd>
          </div>
        ))}
      </dl>
      <h2>{IMPRESSUM.disputeTitle}</h2>
      <p>{IMPRESSUM.dispute}</p>
      <p className="legal__date">{IMPRESSUM.footer}</p>
    </div>
  );
}
